import React from "react";
import { useSelector } from "react-redux";

import { NavigationDots, SocialMedia } from "../components";

const AppWrap = (Component, idName, classNames) =>
  function HOC() {
    const { content } = useSelector((state) => state.content);

    let newIdName;
    if (content.tr) {
      newIdName = idName.tr;
    } else {
      newIdName = idName.en;
    }

    return (
      <div id={newIdName} className={`app__container ${classNames}`}>
        {/* <SocialMedia /> */}
        <div className="app__wrapper app__flex">
          <Component />
          {/* <div className="copyright">
            <p className="p-text">@2022 BULUT</p>
            <p className="p-text">All rights reserved</p>
          </div> */}
        </div>
        <NavigationDots active={newIdName} />
      </div>
    );
  };

export default AppWrap;
